import { supabase } from '../lib/supabase';
import { StripeCheckoutOptions } from '../types';
import toast from 'react-hot-toast';

export const createStripeCheckoutSession = async (options: StripeCheckoutOptions) => {
  try {
    // Show loading toast
    const loadingToastId = toast.loading('Connecting to payment service...');
    
    // Call the Supabase Edge Function to create a Stripe checkout session
    const { data, error } = await supabase.functions.invoke('create-stripe-checkout', {
      body: options
    });

    // Dismiss loading toast
    toast.dismiss(loadingToastId);

    if (error) {
      console.error('Error creating Stripe checkout session:', error);
      
      // Provide more helpful error messages
      if (error.message?.includes('Failed to fetch')) {
        throw new Error('Unable to connect to payment service. Please check your internet connection and try again.');
      } else if (error.message?.includes('not configured')) {
        throw new Error('Payment service is not properly configured. Please contact support.');
      } else {
        throw new Error(error.message || 'Failed to create checkout session');
      }
    }

    if (!data) {
      throw new Error('No response received from payment service');
    }

    if (!data.url) {
      throw new Error('Invalid response from checkout service - missing checkout URL');
    }

    return {
      id: data.id,
      url: data.url
    };
  } catch (error) {
    console.error('Error creating Stripe checkout session:', error);
    
    // Re-throw with more context
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error('An unexpected error occurred while creating the checkout session');
    }
  }
};